import { useTranslation } from "react-i18next";
import { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { formCategoryObject, getPresetSectionsObject } from "../PortalSetings/Configuration/FormsAndFields/constants";
import { formCategories } from "../../../../helpers";
import {
  addValidationToForms,
  checkMandatoryFields,
  formSectionType,
  formStatuses,
  getSectionPermission,
  getUserPermissionForForm,
} from "./constants";
import _ from "lodash";
import { PLATFORM, TOAST_TYPE_ERROR, TOAST_TYPE_SUCCESS, TOAST_TYPE_WARNING } from "../../services/constants";
import { SignTypeValues } from "../../cubeComponent/constants";
import { optionsViewType } from "../PortalSetings/Configuration/FormsAndFields/FormTemplate/constant.helper";
import { showToastNotification } from "../../actions/toast";
import useFormValidator from "../FormValidation/useFormValidator";
import { getContractDetails } from "../../actions/Contracts";
import { getBackendUrl } from "../../utils";
import { getPermissionConstants } from "../Contracts/ContractDetails/constant";
import { presetSectionsCodeObject } from "@Helpers/constants";

interface UseFormsProps {
  navigate?: any;
  params?: any;
  scheduleId?: any;
  contractId?: any;
  resourceId?: any;
  taskInspectionAndProgressFormsController?: any;
  getScheduleDetails?: any;
  GanttDetails?: any;
  userDetails?: any;
  portalData?: any;
  projectData?: any;
  getCurrencyData?: any;
  getContractDetailUrl?: any;
  getFormsListUrl?: any;
  uuid?: any;
  downloadFile?: any;
  mobile?: any;
  navigation?: any;
  axiosWrapper?: any;
  bottomSheetRefFiles?: any;
  bottomSheetRefUsers?: any;
  bottomSheetRefAddedUsers?: any;
  projectId?: any;
  mobileBackendUrl?: any;
}
const useForms = ({
  navigate,
  params,
  scheduleId,
  contractId,
  resourceId,
  taskInspectionAndProgressFormsController = async () => {},
  getScheduleDetails,
  GanttDetails,
  userDetails,
  portalData,
  projectData,
  getCurrencyData,
  getContractDetailUrl,
  getFormsListUrl,
  uuid,
  downloadFile,
  mobile = false,
  navigation,
  axiosWrapper,
  bottomSheetRefFiles,
  bottomSheetRefUsers,
  bottomSheetRefAddedUsers,
  projectId,
  mobileBackendUrl,
}: UseFormsProps) => {
  const { t } = useTranslation();
  const presetSectionsObject: any = getPresetSectionsObject();
  const dispatch = useDispatch();
  const abortControllerList = useRef<any>({});
  const customModules = useSelector((state: any) => state.customModules);

  const selectSignType = (args: any) => {
    const signType = mobile ? args : args.itemData.value;
    if (!userDetails.signature && signType == SignTypeValues.IMPORT_PROFILE_SIGNATURE) {
      dispatch(
        showToastNotification({
          content: t("Profile sign not set"),
          type: TOAST_TYPE_ERROR,
        }),
      );
      if (!mobile) {
        args.cancel = true;
      }
    } else {
      setFormActionDetails((prev: any) => ({
        ...prev,
        signType,
        signDoc: null,
      }));
    }
  };

  const [inspectionData, setInspectionData] = useState<any>({});
  const [showAttachmentModal, setShowAttachmentModal] = useState<any>(false);
  const [attachmentModalOpenedFor, setAttachmentModalOpenedFor] = useState<any>({});
  const [sideBarTaskDetails, setSideBarTaskDetails] = useState<any>([]);
  const [eachAnswerToSave, setEachAnswerToSave] = useState<any>({});
  const [answerSaved, setAnswerSaved] = useState<any>(false);
  const [isFileUploading, setIsFileUploading] = useState<any>([]);
  const [openCommentDialog, setOpenCommentDialog] = useState<any>({
    status: false,
    source: "",
  });
  const [formActionDetails, setFormActionDetails] = useState<any>({
    comment: "",
    signDoc: null,
    signType: SignTypeValues.ATTACH_SIGNED_DOCUMENT,
  });
  const [accordionExpandedState, setAccordionExpandedState] = useState<any>([]);
  const [showSideBar, setShowSideBar] = useState<any>(true);
  const [showAddUsersModal, setShowAddUsersModal] = useState<any>({ status: false });
  const [showWarningModal, setShowWarningModal] = useState<any>({ status: false });
  const [modifySection, setModifySection] = useState<any>([]);
  const [actionBtnDisabled, setActionBtnDisabled] = useState<any>(false);
  const [tableSectionConfig, setTableSectionConfig] = useState<any>({
    height: "max-h-60",
    expandMode: false,
  });
  const [showWaitSpinner, setShowWaitSpinner] = useState<any>(false);
  const formValidator = useFormValidator({});

  // teams and location states for mobile
  const [teamData, setTeamData] = useState<any>(null);
  const [loactionData, setLoactionData] = useState<any>(null);
  const [nameOfTeamLocationRespectToId, setNameOfTeamLocationRespectToId] = useState<any>({});
  const [isDataFetched, setIsDataFetched] = useState<any>(false);
  const [imageFieldSelectedIndex, setImageFieldSelectedIndex] = useState<any>(null);
  const [openExportModal, setOpenExportModal] = useState<any>({
    state: false,
    paperSize: "A4",
    tableFormat: "card",
  });
  const [showUrlModal, setShowUrlModal] = useState<any>({ state: false });
  const [showGeoLocationModal, setShowGeoLocationModal] = useState<any>({ state: false });
  const [URLData, setURLData] = useState<any>({});

  const formObject = useRef(null);

  const ActionItems = inspectionData._id
    ? [
        ...(inspectionData.isSubmitted
          ? [
              {
                text: `${inspectionData.formFlow[inspectionData.currentLevelOfForm].approveBtnTxt}`,
                id: "approve",
                icon: "TickMark",
                disabled: (() => {
                  const allowedUserIdsToApprove = inspectionData.formFlow[
                    inspectionData.currentLevelOfForm
                  ].allowedUsersToApprove?.map((user: any) => user.id);
                  const approveBtnIsDisabled = !(
                    allowedUserIdsToApprove.includes(userDetails.id) && inspectionData.isSubmitted
                  );
                  return approveBtnIsDisabled;
                })(),
              },
            ]
          : [
              {
                text: `${inspectionData.formFlow[inspectionData.currentLevelOfForm].submitBtnTxt}`,
                id: "submit",
                icon: "TickMark",
                disabled: (() => {
                  const allowedUserIdsToSubmit =
                    inspectionData.formFlow[inspectionData.currentLevelOfForm].allowedUsersToSubmit?.map(
                      (user: any) => user.id,
                    ) || [];
                  const submitBtnIsDisabled =
                    !allowedUserIdsToSubmit.includes(userDetails.id) && !inspectionData.isArchived.status;
                  return submitBtnIsDisabled;
                })(),
              },
            ]),
        ...(Object.hasOwn(inspectionData.formFlow[inspectionData.currentLevelOfForm], "allowedUsersToRollBack")
          ? [
              {
                text: `${inspectionData.formFlow[inspectionData.currentLevelOfForm].rollBackBtnTxt}`,
                id: "rollBack",
                icon: "RollBackIcon",
                disabled: (() => {
                  const allowedUserIdsToRollBack =
                    inspectionData.formFlow[inspectionData.currentLevelOfForm].allowedUsersToRollBack?.map(
                      (user: any) => user.id,
                    ) || [];

                  const rollBackBtnIsDisabled = !allowedUserIdsToRollBack.includes(userDetails.id);
                  return rollBackBtnIsDisabled;
                })(),
              },
            ]
          : []),
        ...(Object.hasOwn(inspectionData.formFlow[inspectionData.currentLevelOfForm], "allowedUsersToReject")
          ? [
              {
                text: `${inspectionData.formFlow[inspectionData.currentLevelOfForm].rejectBtnTxt}`,
                id: "reject",
                icon: "Reject",
                disabled: (() => {
                  const allowedUserIdsToReject =
                    inspectionData.formFlow[inspectionData.currentLevelOfForm].allowedUsersToReject?.map(
                      (user: any) => user.id,
                    ) || [];

                  const rejectBtnIsDisabled = !allowedUserIdsToReject.includes(userDetails.id);
                  return rejectBtnIsDisabled;
                })(),
              },
            ]
          : []),
      ]
    : [];

  const sideBarScheduleDetails = [
    {
      name: "Project",
      value: GanttDetails ? GanttDetails.projectsData?.projectId : "",
    },
    {
      name: "Space",
      value: GanttDetails ? GanttDetails.spaceData?.spaceName : "",
    },
    { name: "Schedule", value: GanttDetails ? GanttDetails.title : "" },
    {
      name: "Linked Estimate",
      value: GanttDetails ? GanttDetails.linkedEstimateData?.name : "",
    },
  ];

  const sideBarAccordions = [
    ...(contractId
      ? [
          {
            type: "contractDetails",
            heading: t("Contract Details"),
            iconName: "details",
          },
        ]
      : []),
    { type: "details", heading: t("Details"), iconName: "details" },
    { type: "formFlow", heading: t("Form Flow"), iconName: "activity" },
    { type: "access", heading: t("Access"), iconName: "access" },
    { type: "issues", heading: t("Issues"), iconName: "IssuesIcon" },
  ];

  const fetchFormData = async () => {
    const res = await taskInspectionAndProgressFormsController({ resourceId });
    let data: any = {};
    if (_.get(res, "data.status", false)) {
      data = res.data.result[0];
      if (data) {
        let modifiedData = {
          ...data,
        };
        if (portalData?.frontendUrl?.includes("rustomjee") && data.resourceType == formCategories.bills) {
          const template = data.selectedForm.template?.map((section: any) => {
            const allQuestions = section.questionFields?.map((question: any) => {
              if (question.fieldLabel == "MBOOK_NO" && data.MBOOK_NO) {
                question.answer = {
                  value: data.MBOOK_NO,
                };
              }
              if (question.fieldLabel == "SES_NO" && data.SES_NO) {
                question.answer = {
                  value: data.SES_NO,
                };
              }
              return question;
            });
            section.questionFields = allQuestions;
            return section;
          });

          modifiedData = {
            ...data,
            selectedForm: {
              ...data.selectedForm,
              template,
            },
          };
        }
        setInspectionData(() => ({ ...modifiedData }));
      }
    }
    setIsDataFetched(true);
    return data;
  };
  const setInitialData = async () => {
    const data = await fetchFormData();
    if (data._id) {
      axiosWrapper.post(`${getBackendUrl()}/recentAccess/recentAccess`, {
        module: data.resourceType,
        metaData: {
          _id: resourceId,
          name: data.title,
          projectId: data.projectId,
          resourceType: data.resourceType,
        },
        projectId: data.projectId,
        platform: mobile ? PLATFORM.mobile : PLATFORM.web,
      });
      if (!mobile) {
        handleExpandAll(data.selectedForm?.template);
      }
    }
    if (data.contractId) {
      dispatch(getContractDetails({ contractId: data.contractId }));
      dispatch(getCurrencyData({ projectId: params.projectId }));
    }
    if (scheduleId) {
      dispatch(getScheduleDetails({ ganttId: scheduleId }));
    }
  };
  useEffect(() => {
    setInitialData();
  }, []);

  async function getLocationForMobile() {
    let teamResponse = await axiosWrapper.post(`${mobileBackendUrl}/projects/locationController`, {
      value: { params: { projectId }, projectId },
    });
    teamResponse = teamResponse.data.result;
    const nameDataOfTeamRespectToId: any = {};
    teamResponse = teamResponse.map((data: any) => {
      nameDataOfTeamRespectToId[data._id] = data.name;
      return {
        label: data.name,
        value: data._id,
        ...data,
      };
    });
    setNameOfTeamLocationRespectToId({
      ...nameOfTeamLocationRespectToId,
      ...nameDataOfTeamRespectToId,
    });
    return teamResponse;
  }

  async function getTeamDataForMobile() {
    let locationResponse = await axiosWrapper.post(`${mobileBackendUrl}/projects/teamsController`, {
      value: { params: { projectId }, projectId },
    });
    locationResponse = locationResponse.data.result;
    const nameDataOfTeamRespectToId: any = {};
    locationResponse = locationResponse.map((data: any) => {
      nameDataOfTeamRespectToId[data._id] = data.name;
      const dataToReturn = {
        label: data.name,
        value: data._id,
        ...data,
      };
      if (data.parentId) {
        dataToReturn.parent = data.parentId;
      }
      return dataToReturn;
    });
    setNameOfTeamLocationRespectToId({
      ...nameOfTeamLocationRespectToId,
      ...nameDataOfTeamRespectToId,
    });
    return locationResponse;
  }

  const handleChangeAnswer = ({
    source,
    answerValue,
    fieldIndex,
    sectionIndex,
    tableRowIndex,
    questionId,
  }: {
    source: any;
    answerValue: any;
    fieldIndex: any;
    sectionIndex: any;
    tableRowIndex: any;
    questionId: any;
  }) => {
    if (source == formSectionType.FORM) {
      setInspectionData((prev: any) => {
        const modifiedTemplate = [...prev.selectedForm.template];
        if (modifiedTemplate[sectionIndex].questionFields[fieldIndex].answer) {
          modifiedTemplate[sectionIndex].questionFields[fieldIndex].answer = {
            ...modifiedTemplate[sectionIndex].questionFields[fieldIndex].answer,
            value: answerValue,
          };
        } else {
          modifiedTemplate[sectionIndex].questionFields[fieldIndex].answer = {
            value: answerValue,
          };
        }
        return {
          ...prev,
          selectedForm: {
            ...prev.selectedForm,
            template: modifiedTemplate,
          },
        };
      });
    } else {
      setInspectionData((prev: any) => {
        const modifiedTemplate = [...prev.selectedForm.template];
        const modifiedTableDataSource = modifiedTemplate[sectionIndex].tableDataSource.map((row: any, index: any) => {
          if (index == tableRowIndex) {
            row[questionId] = {
              createdDate: Date.now(),
              createdBy: userDetails._id,
              value: answerValue,
            };
          }
          return row;
        });
        modifiedTemplate[sectionIndex].tableDataSource = modifiedTableDataSource;
        return {
          ...prev,
          selectedForm: {
            ...prev.selectedForm,
            template: modifiedTemplate,
          },
        };
      });
    }
  };

  function getMultiSelectValue(args: any, currentAnswer: any, viewType: any) {
    if (viewType === optionsViewType.LIST) {
      const prevAns = currentAnswer?.value || [];
      return args.checked ? [...prevAns, args.value] : prevAns.filter((ans: any) => ans !== args.value);
    }

    if (viewType === optionsViewType.DROPDOWN) {
      if (currentAnswer.value) {
        const currentData = args[0];
        const exists = currentAnswer.value.includes(currentData);
        return exists
          ? currentAnswer.value.filter((item: any) => item !== currentData)
          : [...currentAnswer.value, currentData];
      }
      return args;
    }

    return [];
  }

  function getLookUpValue(args: any, answerValue: any, nameMap: any) {
    const prevAns = answerValue?.value || [];
    return args
      .map((id: any) => ({
        id,
        name: nameMap[id],
      }))
      .concat(prevAns);
  }

  const handleMobile = ({
    args,
    answerValue,
    sectionIndex,
    eachField,
    section,
    source,
    tableRowIndex,
    fieldIndex,
  }: {
    args: any;
    source: any;
    answerValue: any;
    fieldIndex: any;
    sectionIndex: any;
    tableRowIndex: any;
    eachField: any;
    section: any;
  }) => {
    const { _id, fieldType, viewType = optionsViewType.LIST } = eachField;
    let currentAnswer = eachField.answer ?? {};

    if (source === formSectionType.TABLE_SECTION) {
      currentAnswer = section.tableDataSource[tableRowIndex]?.[_id] ?? {};
    }

    switch (fieldType) {
      case "single-line":
      case "multi-line":
      case "single-select":
        answerValue = args;
        break;

      case "multi-select":
        answerValue = getMultiSelectValue(args, currentAnswer, viewType);
        break;

      case "date-time":
        answerValue = args.getTime();
        break;

      case "look-up":
        answerValue = getLookUpValue(args, answerValue, nameOfTeamLocationRespectToId);
        break;

      case "number":
        answerValue = Number(args.replace(/\D/g, ""));
        break;

      case "geoLocation":
        answerValue = args;
        break;

      default:
        break;
    }

    handleChangeAnswer({
      source,
      answerValue,
      fieldIndex,
      sectionIndex,
      tableRowIndex,
      questionId: _id,
    });
  };

  const handleInputChange = async ({
    args,
    answerValue,
    sectionIndex,
    eachField,
    section,
    source = "",
    tableRowIndex,
    fieldIndex,
  }: {
    args: any;
    answerValue: any;
    sectionIndex: any;
    eachField: any;
    section: any;
    source: any;
    tableRowIndex: any;
    fieldIndex: any;
  }) => {
    const { _id } = eachField;

    const questionId: any = _id;
    const sectionId: any = section._id;
    if (mobile) {
      handleMobile({
        args,
        answerValue,
        sectionIndex,
        eachField,
        section,
        source,
        tableRowIndex,
        fieldIndex,
      });
    }
    if (![undefined, NaN].includes(answerValue)) {
      if (source == formSectionType.FORM) {
        setEachAnswerToSave({
          sectionId,
          questionId,
          answer: { value: answerValue },
        });
      } else {
        const modifiedTemplate = _.cloneDeep(inspectionData.selectedForm.template);
        const modifiedTableDataSource = modifiedTemplate[sectionIndex].tableDataSource.map((row: any, index: any) => {
          if (index == tableRowIndex) {
            row[_id] = {
              createdDate: Date.now(),
              createdBy: userDetails._id,
              value: answerValue,
            };
          }
          return row;
        });
        setEachAnswerToSave({
          tableSectionId: sectionId,
          tableSectionDataSource: modifiedTableDataSource,
        });
      }
    }
  };

  const fileToBase64 = async (file: any) =>
    new Promise((resolve) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result);
      reader.onerror = (e) => {
        console.log(e);
      };
    });

  const validateMaxFiles = (eachField: any, prevAns: any) => {
    if (eachField.maxNoOfFiles && prevAns && prevAns.length >= eachField.maxNoOfFiles) {
      dispatch(
        showToastNotification({
          content: `Max only ${eachField.maxNoOfFiles} files can be uploaded`,
          type: TOAST_TYPE_ERROR,
        }),
      );
      return false;
    }
    return true;
  };

  const validateFileType = (file: any, eachField: any, allowedFileTypes: any) => {
    if (
      (eachField.fieldType === "image" && !allowedFileTypes.includes(file.type)) ||
      (eachField.fieldType === "fileUpload" && allowedFileTypes.length && !allowedFileTypes.includes(file.type))
    ) {
      dispatch(
        showToastNotification({
          content: t("File type not allowed"),
          type: TOAST_TYPE_ERROR,
        }),
      );
      return false;
    }
    return true;
  };

  const validateFileSize = (file: any, e: any) => {
    const maxFileSizeInBytes = 10 * 1024 * 1024;
    if (file.size > maxFileSizeInBytes) {
      const msg = "File size exceeds the limit. Max file size allowed is 10 MB";
      if (mobile) {
        dispatch(showToastNotification({ content: msg, type: TOAST_TYPE_WARNING }));
      } else {
        alert(msg);
        e.target.value = "";
      }
      return false;
    }
    return true;
  };

  const updateFormTemplate = (args: any, fileMeta: any, fileBase64Str: any) => {
    const { formData, sectionIndex, fieldIndex, sectionId, eachField, tableRowIndex, source, userDetails } = args;
    const questionId = eachField._id;
    const modifiedTemplate = _.cloneDeep(formData.selectedForm.template);
    let answerValue = [{ ...fileMeta }];

    if (source === formSectionType.FORM) {
      if (eachField.answer?.value) {
        answerValue = [...eachField.answer.value, fileMeta];
      }
      modifiedTemplate[sectionIndex].questionFields[fieldIndex].answer = { value: answerValue };

      return {
        template: modifiedTemplate,
        data: {
          addFileUploadFieldData: { fileBase64Str, awsKey: fileMeta.awsKey },
          answer: { value: answerValue },
          sectionId,
          questionId,
        },
      };
    }

    const prevAns = formData.selectedForm.template[sectionIndex].tableDataSource[tableRowIndex][questionId]?.value;
    if (prevAns) answerValue = [...prevAns, fileMeta];

    modifiedTemplate[sectionIndex].tableDataSource = modifiedTemplate[sectionIndex].tableDataSource.map(
      (row: any, i: any) =>
        i === tableRowIndex
          ? {
              ...row,
              [questionId]: { createdBy: userDetails._id, createdDate: Date.now(), value: answerValue },
            }
          : row,
    );

    return {
      template: modifiedTemplate,
      data: {
        tableSectionId: sectionId,
        tableSectionDataSource: [...modifiedTemplate[sectionIndex].tableDataSource],
        addFileUploadFieldData: { fileBase64Str, awsKey: fileMeta.awsKey },
      },
    };
  };
  const handleFileUploadChange = async (args: any) => {
    const {
      e,
      eachField,
      sectionIndex,
      tableRowIndex,
      source,
      tableRowId = null,
      formData = {},
      handleCustomFieldData,
    } = args;

    const questionId = eachField._id;
    const allowedFileTypes = eachField.allowedFileTypes || [];
    let prevAns = eachField.answer?.value;

    if (source === formSectionType.TABLE_SECTION) {
      prevAns = formData.selectedForm.template[sectionIndex].tableDataSource[tableRowIndex]?.[questionId]?.value;
    }

    if (!validateMaxFiles(eachField, prevAns)) return;
    const file = mobile ? e : e.target.files?.[0];
    if (!file) return;
    if (!validateFileType(file, eachField, allowedFileTypes)) return;
    if (!validateFileSize(file, e)) return;

    const fileBase64Str = mobile ? file.base64 : await fileToBase64(file);
    const awsKey = uuid();
    const fileMeta = { type: file.type, name: file.name || file.fileName, awsKey };

    const { template, data } = updateFormTemplate(args, fileMeta, fileBase64Str);

    setIsFileUploading((prev: any) => [
      ...prev,
      { type: eachField.fieldType, uniqueId: tableRowId ? `${tableRowId}${questionId}` : questionId },
    ]);

    if (handleCustomFieldData) return; // placeholder for custom handler

    if (inspectionData._id) {
      const res = await taskInspectionAndProgressFormsController({ action: "update", _id: resourceId, data });
      setIsFileUploading((prev: any) =>
        prev.filter((d: any) => d.uniqueId !== (tableRowId ? `${tableRowId}${questionId}` : questionId)),
      );

      if (res.data.status) {
        setAnswerSaved(true);
        if (!mobile) setTimeout(() => setAnswerSaved(false), 500);
        dispatch(showToastNotification({ content: "File uploaded", type: TOAST_TYPE_SUCCESS }));
        setInspectionData((prev: any) => ({
          ...prev,
          lastSaved: res.data.lastSaved,
          selectedForm: { ...prev.selectedForm, template },
        }));
      } else {
        dispatch(showToastNotification({ content: res.data.errorMessage, type: TOAST_TYPE_ERROR }));
      }
    }
  };

  const saveEditedImage = ({
    base64EncodedImg,
    awsKey,
    handleCustomFieldData,
    sectionId,
    questionId,
  }: {
    base64EncodedImg: any;
    awsKey: any;
    handleCustomFieldData: any;
    sectionId: any;
    questionId: any;
  }) => {
    if (handleCustomFieldData) {
      return;
    } else if (inspectionData._id) {
      setEachAnswerToSave({
        addFileUploadFieldData: { fileBase64Str: base64EncodedImg, awsKey },
        sectionId,
        questionId,
      });
    }
  };

  const handleRemoveUploadedFile = ({
    fileData,
    sectionIndex,
    fieldIndex,
    sectionId,
    questionId,
    source,
    tableRowIndex,
    handleCustomFieldData,
  }: {
    fileData: any;
    sectionIndex: any;
    fieldIndex: any;
    sectionId: any;
    questionId: any;
    source: any;
    tableRowIndex: any;
    handleCustomFieldData: any;
  }) => {
    const { awsKey, fileVersion } = fileData;
    const matchingValue = awsKey || fileVersion;
    const matchingKey = awsKey ? "awsKey" : "fileVersion";
    const modifiedTemplate = _.cloneDeep(inspectionData.selectedForm.template);

    if (handleCustomFieldData) {
      return;
    } else if (inspectionData._id) {
      if (source == formSectionType.FORM) {
        const modifiedAnswer = modifiedTemplate[sectionIndex].questionFields[fieldIndex].answer?.value.filter(
          (data: any) => data[matchingKey] != matchingValue,
        );

        modifiedTemplate[sectionIndex].questionFields[fieldIndex].answer = {
          ...modifiedTemplate[sectionIndex].questionFields[fieldIndex].answer,
          value: modifiedAnswer,
        };

        setInspectionData((prev: any) => ({
          ...prev,
          selectedForm: {
            ...prev.selectedForm,
            template: modifiedTemplate,
          },
        }));

        const payload: any = {
          answer: { value: modifiedAnswer },
          sectionId,
          questionId,
        };
        if (awsKey) {
          payload.removeFileUploadFieldData = { awsKey };
        }
        setEachAnswerToSave(payload);
      } else {
        const modifiedAnswer = modifiedTemplate[sectionIndex].tableDataSource[tableRowIndex][questionId]?.value.filter(
          (data: any) => data[matchingKey] != matchingValue,
        );

        modifiedTemplate[sectionIndex].tableDataSource = modifiedTemplate[sectionIndex].tableDataSource.map(
          (row: any, index: any) => {
            if (index == tableRowIndex) {
              row[questionId] = {
                createdBy: userDetails._id,
                createdDate: Date.now(),
                value: modifiedAnswer,
              };
            }
            return row;
          },
        );

        setInspectionData((prev: any) => ({
          ...prev,
          selectedForm: {
            ...prev.selectedForm,
            template: modifiedTemplate,
          },
        }));

        const payload: any = {
          tableSectionId: sectionId,
          tableSectionDataSource: [...modifiedTemplate[sectionIndex].tableDataSource],
        };
        if (awsKey) {
          payload.removeFileUploadFieldData = { awsKey };
        }
        setEachAnswerToSave(payload);
      }
    }
  };

  const manageAbortControllers = (questionId: any, abortController: any) => {
    if (!questionId) return;

    const existingControllers: any = _.get(abortControllerList, `current.${questionId}`);
    if (existingControllers) {
      existingControllers.forEach((c: any) => c.abort());
      abortControllerList.current[questionId] = [];
    }

    if (abortControllerList.current[questionId]) {
      abortControllerList.current[questionId].push(abortController);
    } else {
      abortControllerList.current[questionId] = [abortController];
    }
  };
  const updateAttachments = (res: any, eachAnswerToSave: any, setInspectionData: any) => {
    if (!res.data.addedAttachmentData) return;

    const { obj } = res.data.addedAttachmentData;
    const { sectionIndex, fieldIndex } = eachAnswerToSave;

    setInspectionData((prev: any) => {
      prev.selectedForm.template[sectionIndex].questionFields[fieldIndex].attachmentsData = [
        ...prev.selectedForm.template[sectionIndex].questionFields[fieldIndex].attachmentsData,
        { ...obj },
      ];
      return { ...prev, lastSaved: res.data.lastSaved };
    });
  };
  const setEachAnswer = async () => {
    if (!Object.keys(eachAnswerToSave).length) return;

    const abortController = new AbortController();
    const questionId = _.get(eachAnswerToSave, "questionId") || _.get(eachAnswerToSave, "tableSectionId");

    manageAbortControllers(questionId, abortController);

    try {
      const res = await taskInspectionAndProgressFormsController(
        { action: "update", _id: resourceId, data: eachAnswerToSave },
        abortController,
      );

      updateAttachments(res, eachAnswerToSave, setInspectionData);

      if (res.data.status) {
        setAnswerSaved(true);
        setTimeout(() => setAnswerSaved(false), 500);
        setInspectionData((prev: any) => ({
          ...prev,
          lastSaved: res.data.lastSaved,
        }));
      } else {
        dispatch(
          showToastNotification({
            content: res.data.errorMessage,
            type: TOAST_TYPE_ERROR,
          }),
        );
      }
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    setEachAnswer();
  }, [eachAnswerToSave]);

  useEffect(() => {
    if (inspectionData?._id && isDataFetched) {
      addValidationToForms({
        formValidator,
        inspectionData,
        modifySection,
      });
    }
  }, [inspectionData?._id, inspectionData?.currentLevelOfForm, modifySection, isDataFetched]);

  const openAddUserModal = ({
    eachField,
    fieldIndex,
    sectionIndex,
    section,
    source = formSectionType.FORM,
    tableRowIndex,
    handleCustomFieldData,
  }: {
    eachField: any;
    fieldIndex: any;
    sectionIndex: any;
    section: any;
    source: any;
    tableRowIndex: any;
    handleCustomFieldData: any;
  }) => {
    if (eachField.onlyCurrentUser) {
      const currentUser = {
        _id: userDetails.id,
        signature: userDetails.signature,
        firstName: userDetails.firstName,
        fullName: userDetails.fullName,
        lastName: userDetails.lastName,
      };
      if (handleCustomFieldData) {
        return;
      } else if (inspectionData._id) {
        const modifiedTemplate = _.cloneDeep(inspectionData.selectedForm.template);
        if (source == formSectionType.FORM) {
          modifiedTemplate[sectionIndex].questionFields[fieldIndex].answer = {
            value: [currentUser],
          };
          setInspectionData((prev: any) => ({
            ...prev,
            selectedForm: {
              ...prev.selectedForm,
              template: modifiedTemplate,
            },
          }));

          setEachAnswerToSave({
            sectionId: section._id,
            questionId: eachField._id,
            answer: { value: [currentUser] },
          });
        } else {
          modifiedTemplate[sectionIndex].tableDataSource[tableRowIndex][eachField._id] = {
            createdBy: userDetails._id,
            createdDate: Date.now(),
            value: [currentUser],
          };
          setInspectionData((prev: any) => ({
            ...prev,
            selectedForm: {
              ...prev.selectedForm,
              template: modifiedTemplate,
            },
          }));

          setEachAnswerToSave({
            tableSectionId: section._id,
            tableSectionDataSource: [...modifiedTemplate[sectionIndex].tableDataSource],
          });
        }
        if (mobile) {
          dispatch(
            showToastNotification({
              content: t("User Added"),
              type: TOAST_TYPE_SUCCESS,
            }),
          );
        }
      }
    } else if (handleCustomFieldData) {
      return;
    } else if (inspectionData._id) {
      setShowAddUsersModal({
        status: true,
        fieldData: { ...eachField },
        fieldIndex,
        sectionIndex,
        section,
        source,
        tableRowIndex,
      });
      bottomSheetRefUsers?.current?.snapToIndex(0);
    }
  };

  const closeUsersModal = () => {
    setShowAddUsersModal({ status: false });
  };

  const removeUserFromList = ({
    fieldIndex,
    sectionIndex,
    user,
    eachField,
    section,
    source = formSectionType.FORM,
    tableRowIndex,
    handleCustomFieldData,
  }: {
    fieldIndex: any;
    sectionIndex: any;
    user: any;
    eachField: any;
    section: any;
    source: any;
    tableRowIndex: any;
    handleCustomFieldData: any;
  }) => {
    const modifiedTemplate = _.cloneDeep(inspectionData.selectedForm.template);

    if (handleCustomFieldData) {
      return;
    } else if (inspectionData._id) {
      if (source == formSectionType.FORM) {
        const allUsers = modifiedTemplate[sectionIndex].questionFields[fieldIndex].answer.value;
        const filteredUsers = allUsers.filter((data: any) => data._id != user._id);

        modifiedTemplate[sectionIndex].questionFields[fieldIndex].answer = {
          value: filteredUsers,
        };

        setInspectionData((prev: any) => ({
          ...prev,
          selectedForm: {
            ...prev.selectedForm,
            template: modifiedTemplate,
          },
        }));

        setEachAnswerToSave({
          sectionId: section._id,
          questionId: eachField._id,
          answer: { value: filteredUsers },
        });

        mobile &&
          setShowAddUsersModal({
            ...showAddUsersModal,
            status: true,
            fieldData: modifiedTemplate[sectionIndex].questionFields[fieldIndex],
            fieldIndex,
            sectionIndex,
            section,
            source,
            tableRowIndex,
          });
      } else {
        const allUsers = modifiedTemplate[sectionIndex].tableDataSource[tableRowIndex][eachField._id].value;
        const filteredUsers = allUsers.filter((data: any) => data._id != user._id);

        modifiedTemplate[sectionIndex].tableDataSource[tableRowIndex][eachField._id] = {
          createdBy: userDetails._id,
          createdDate: Date.now(),
          value: filteredUsers,
        };

        setInspectionData((prev: any) => ({
          ...prev,
          selectedForm: {
            ...prev.selectedForm,
            template: modifiedTemplate,
          },
        }));

        setEachAnswerToSave({
          tableSectionId: section._id,
          tableSectionDataSource: [...modifiedTemplate[sectionIndex].tableDataSource],
        });
        mobile &&
          setShowAddUsersModal({
            ...showAddUsersModal,
            status: true,
            fieldData: modifiedTemplate[sectionIndex].questionFields[fieldIndex],
            fieldIndex,
            sectionIndex,
            section,
            source,
            tableRowIndex,
          });
      }
    }
  };

  const openAddedUserModalInMobile = ({
    eachField,
    fieldIndex,
    sectionIndex,
    showCrossIcon = false,
    section,
    source,
    tableRowIndex,
  }: {
    eachField: any;
    fieldIndex: any;
    sectionIndex: any;
    showCrossIcon: any;
    section: any;
    source: any;
    tableRowIndex: any;
  }) => {
    setShowAddUsersModal({
      status: true,
      fieldData: { ...eachField },
      fieldIndex,
      sectionIndex,
      showCrossIcon,
      section,
      source,
      tableRowIndex,
    });
    bottomSheetRefAddedUsers?.current?.snapToIndex(0);
  };

  const verifySection = (sectionIds: any) => {
    let uniqueSectionIds: any = new Set([...sectionIds, ...inspectionData.sectionsVerified]);
    uniqueSectionIds = Array.from(uniqueSectionIds);
    setInspectionData((prev: any) => ({
      ...prev,
      sectionsVerified: uniqueSectionIds,
    }));
    setEachAnswerToSave({ sectionsVerified: [...uniqueSectionIds] });
  };

  function handleAttachmentClick(sectionIndex: any, fieldIndex: any) {
    setShowAttachmentModal(true);
    setAttachmentModalOpenedFor({
      sectionIndex,
      fieldIndex,
    });
    bottomSheetRefFiles?.current?.snapToIndex(0);
  }

  const closeAttachmentModal = () => {
    setShowAttachmentModal(false);
  };

  const handleModifyCancel = (event: any, sectionId: any) => {
    event?.stopPropagation();
    setModifySection((prev: any) => prev.filter((id: any) => id != sectionId));
  };

  const verifyToggleStatus = (section: any) => {
    const allowedUsersToVerifyPostSub = section.permissions[inspectionData.currentLevelOfForm].Verify;
    return !(allowedUsersToVerifyPostSub.includes(userDetails.id) && inspectionData.isSubmitted);
  };

  const saveInspectionData = async (type: any) => {
    const data: any = {};
    if (type == "submit") {
      if (inspectionData.currentLevelOfForm == inspectionData.formFlow.length - 2) {
        data.isSubmitted = true;
      } else {
        data.isSubmitted = false;
        data.proceedToNextLevel = true;
      }
    } else if (type == "approve") {
      data.isApproved = true;
      data.actionComment = formActionDetails.comment;
      data.actionSignDoc = formActionDetails.signDoc;
      data.actionSignType = formActionDetails.signType;
    } else if (type == "reject") {
      data.isRejected = true;
      data.actionComment = formActionDetails.comment;
      data.actionSignDoc = formActionDetails.signDoc;
      data.actionSignType = formActionDetails.signType;
    }
    setActionBtnDisabled(true);
    const res = await taskInspectionAndProgressFormsController({
      action: "update",
      _id: resourceId,
      data,
    });
    setActionBtnDisabled(false);
    return res;
  };

  const handleRollBack = async () => {
    setActionBtnDisabled(true);
    const res = await taskInspectionAndProgressFormsController({
      action: "update",
      _id: resourceId,
      data: {
        rollBack: true,
      },
    });
    if (res.data.status) {
      dispatch(
        showToastNotification({
          content: t("Form Rolled back to previous level"),
          type: TOAST_TYPE_SUCCESS,
        }),
      );
      const updatedFormFLow = [...inspectionData.formFlow];
      updatedFormFLow[inspectionData.currentLevelOfForm - 1].actionStatus = false;
      updatedFormFLow[inspectionData.currentLevelOfForm - 1].actionDetails = {};
      setInspectionData((prev: any) => ({
        ...prev,
        isSubmitted: false,
        status: formStatuses.inProgress,
        formFlow: updatedFormFLow,
        sectionsVerified: [],
        currentLevelOfForm: prev.currentLevelOfForm - 1,
      }));
    } else {
      dispatch(
        showToastNotification({
          content: res.data.errorMessage,
          type: TOAST_TYPE_ERROR,
        }),
      );
    }
    setActionBtnDisabled(false);
  };

  const handleFormActionClick = (args: any) => {
    if (args.item.id == "approve") {
      setOpenCommentDialog({ status: true, source: "Approve" });
    }
    if (args.item.id == "reject") {
      setOpenCommentDialog({ status: true, source: "Reject" });
    }
    if (args.item.id == "submit") {
      handleSubmitClick();
    }
    if (args.item.id == "rollBack") {
      handleRollBack();
    }
  };

  const beforeOpenActionDropdown = (args: any) => {
    if (Object.hasOwn(inspectionData.formFlow[inspectionData.currentLevelOfForm], "allowedUsersToRollBack")) {
      const allowedUserIdsToRollBack =
        inspectionData.formFlow[inspectionData.currentLevelOfForm].allowedUsersToRollBack?.map(
          (user: any) => user.id,
        ) || [];

      const rollBackBtnIsDisabled = !allowedUserIdsToRollBack.includes(userDetails.id);
      args.items[1].disabled = rollBackBtnIsDisabled;
    }

    if (Object.hasOwn(inspectionData.formFlow[inspectionData.currentLevelOfForm], "allowedUsersToReject")) {
      const allowedUserIdsToReject = inspectionData.formFlow[
        inspectionData.currentLevelOfForm
      ].allowedUsersToReject?.map((user: any) => user.id);

      const rejectBtnIsDisabled = !allowedUserIdsToReject.includes(userDetails.id);
      let index = 1;
      if (Object.hasOwn(inspectionData.formFlow[inspectionData.currentLevelOfForm], "allowedUsersToRollBack")) {
        index = 2;
      }
      args.items[index].disabled = rejectBtnIsDisabled;
    }

    if (inspectionData.isSubmitted) {
      const allowedUserIdsToApprove = inspectionData.formFlow[
        inspectionData.currentLevelOfForm
      ].allowedUsersToApprove?.map((user: any) => user.id);
      const approveBtnIsDisabled = !(allowedUserIdsToApprove.includes(userDetails.id) && inspectionData.isSubmitted);
      args.items[0].disabled = approveBtnIsDisabled;
    } else {
      const allowedUserIdsToSubmit = inspectionData.formFlow[
        inspectionData.currentLevelOfForm
      ].allowedUsersToSubmit?.map((user: any) => user.id);
      const submitBtnIsDisabled = !allowedUserIdsToSubmit.includes(userDetails.id) && !inspectionData.isArchived.status;
      args.items[0].disabled = submitBtnIsDisabled;
    }
  };

  const handleFormStateChange = async () => {
    const res = await taskInspectionAndProgressFormsController({
      action: "archive",
      resourceIds: [inspectionData._id],
      data: { isArchived: { status: true } },
    });

    if (res.data.status) {
      dispatch(
        showToastNotification({
          content: t("Successfully Archived"),
          type: TOAST_TYPE_SUCCESS,
        }),
      );
    }
    let urlLink;
    if (inspectionData?.contractId) {
      urlLink = getContractDetailUrl({
        selectedTab: formCategoryObject[inspectionData.resourceType].selectedTab,
        projectId: params.projectId,
        contractId: inspectionData?.contractId,
      });
    } else {
      urlLink = getFormsListUrl({
        selectedTab: "list",
        projectId: params.projectId,
        resourceType: inspectionData.resourceType,
      });
    }
    navigate(urlLink);
  };

  const handleCollapseAll = () => {
    setAccordionExpandedState([]);
  };
  const handleExpandAll = (template = []) => {
    const sectionIds: any = template?.map((section: any) => section._id);
    setAccordionExpandedState([...sectionIds]);
  };

  const handleAccStateChange = (args: any, sectionId: any) => {
    setAccordionExpandedState((prev: any) => {
      if (prev.includes(sectionId)) {
        return prev.filter((id: any) => id != sectionId);
      }

      return [...prev, sectionId];
    });
  };

  const showToastAndRedirect = (content: any) => {
    dispatch(
      showToastNotification({
        content,
        type: TOAST_TYPE_SUCCESS,
      }),
    );
    if (inspectionData?.contractId) {
      if (!mobile) {
        const urlLink = getContractDetailUrl({
          selectedTab: formCategoryObject[inspectionData.resourceType].selectedTab,
          projectId: params.projectId,
          contractId: inspectionData?.contractId,
        });
        navigate(urlLink);
      } else {
        navigation.replace("FormsList", {
          formList: inspectionData.resourceType,
          projectId: params.projectId,
          contractId: inspectionData?.contractId,
        });
      }
    } else if (!mobile) {
      const urlLink = getFormsListUrl({
        selectedTab: "list",
        projectId: params.projectId,
        resourceType: inspectionData.resourceType,
      });
      navigate(urlLink);
    } else {
      navigation.replace("FormsList", {
        formList: inspectionData.resourceType,
        projectId: params.projectId,
      });
    }
  };

  const handleSubmitClick = async () => {
    const { isAllMandatoryFieldsFilled, errorToastContent } = checkMandatoryFields(inspectionData);
    if (isAllMandatoryFieldsFilled) {
      const res = await saveInspectionData("submit");
      if (res.data.status) {
        await fetchFormData();
        dispatch(
          showToastNotification({
            content: t("Form submitted successfully navigate back to see full list"),
            type: TOAST_TYPE_SUCCESS,
          }),
        );
      } else {
        dispatch(
          showToastNotification({
            content: res.data.errorMessage,
            type: TOAST_TYPE_ERROR,
          }),
        );
      }
    } else {
      dispatch(
        showToastNotification({
          content: errorToastContent,
          type: TOAST_TYPE_ERROR,
        }),
      );
      formValidator.validateAll();
    }
  };

  const closeCommentDialog = () => {
    setOpenCommentDialog(false);
    setShowWaitSpinner(false);
    setFormActionDetails({
      comment: "",
      signDoc: null,
      signType: SignTypeValues.ATTACH_SIGNED_DOCUMENT,
    });
  };

  const handleApproveClick = async () => {
    if (inspectionData.sectionsVerified?.length != inspectionData.selectedForm.template.length) {
      dispatch(
        showToastNotification({
          content: t("Please verify all sections before approving the form"),
          type: TOAST_TYPE_ERROR,
        }),
      );
    } else {
      setShowWaitSpinner(true);
      const res = await saveInspectionData("approve");
      if (res.data.status) {
        showToastAndRedirect("Form Approved Successfully");
        setShowWaitSpinner(false);
      } else {
        dispatch(
          showToastNotification({
            content: res.data.errorMessage,
            type: TOAST_TYPE_ERROR,
          }),
        );
        setShowWaitSpinner(false);
      }
    }
  };

  function verifyAllState() {
    let isVerifyAllDisabled = true;
    _.get(inspectionData, "selectedForm.template", []).forEach((section: any) => {
      const secPermission = getSectionPermission({
        section,
        inspectionData,
        userId: userDetails.id,
        type: "Verify",
      });
      if (secPermission && inspectionData.sectionsVerified.length < inspectionData.selectedForm.template.length) {
        isVerifyAllDisabled = false;
      }
    });
    return isVerifyAllDisabled;
  }

  const handleSaveCmntClick = async () => {
    if (openCommentDialog.source == "Reject") {
      setShowWaitSpinner(true);
      const res = await saveInspectionData("reject");
      if (res.data.status) {
        showToastAndRedirect(res.data.message);
        setShowWaitSpinner(false);
      } else {
        dispatch(
          showToastNotification({
            content: res.data.errorMessage,
            type: TOAST_TYPE_ERROR,
          }),
        );
        setShowWaitSpinner(false);
      }
    } else {
      handleApproveClick();
    }
  };

  function onClickWarningModalConfirm({ source, showWarningModal }: { source: any; showWarningModal: any }) {
    if (source == "verify") {
      verifySection([showWarningModal.data._id]);
    }
    if (source == "modify") {
      setModifySection((prev: any) => [...prev, showWarningModal.data._id]);
    }
    if (source == "verifyAll") {
      const tempSectionIds: any = [];
      inspectionData.selectedForm.template?.map((section: any) => {
        const permission = getSectionPermission({
          section,
          inspectionData,
          userId: userDetails.id,
          type: "Verify",
        });
        if (permission) {
          tempSectionIds.push(section._id);
        }
      });
      verifySection([...tempSectionIds]);
    }
    hideWarningModal();
  }

  const handleShowWarningModal = (event: any, source: any, section: any) => {
    event?.stopPropagation();
    setShowWarningModal({ status: true, source, data: section });
  };
  const hideWarningModal = () => {
    setShowWarningModal({ status: false });
  };

  const handleExportPdf = async () => {
    const formData = {
      formId: inspectionData._id,
      projectId: inspectionData.projectId,
      paperSize: openExportModal.paperSize,
      tableSectionFormat: openExportModal.tableFormat,
    };
    setOpenExportModal({ state: false, paperSize: "A4", tableFormat: "card" });
    downloadFile({ formData, type: "Download" });
  };

  const handleAddTableRowClick = ({ section, sectionIndex }: { section: any; sectionIndex: any }) => {
    const newObjRow: any = {
      rowId: uuid(),
    };
    inspectionData.selectedForm.template[sectionIndex].questionFields.map((field: any) => {
      newObjRow[field._id] = {};
    });
    const modifiedTemplate = _.cloneDeep(inspectionData.selectedForm.template);

    modifiedTemplate[sectionIndex].tableDataSource = [...modifiedTemplate[sectionIndex].tableDataSource, newObjRow];

    setInspectionData((prev: any) => ({
      ...prev,
      selectedForm: {
        ...prev.selectedForm,
        template: modifiedTemplate,
      },
    }));

    setEachAnswerToSave({
      tableSectionId: section._id,
      tableSectionDataSource: [...modifiedTemplate[sectionIndex].tableDataSource],
    });
  };

  const handleDeleteTableRow = ({
    section,
    sectionIndex,
    rowIndex,
  }: {
    section: any;
    sectionIndex: any;
    rowIndex: any;
  }) => {
    const modifiedTemplate = _.cloneDeep(inspectionData.selectedForm.template);

    const dataSource = modifiedTemplate[sectionIndex].tableDataSource;

    dataSource.splice(rowIndex, 1);

    modifiedTemplate[sectionIndex].tableDataSource = [...dataSource];

    setInspectionData((prev: any) => ({
      ...prev,
      selectedForm: {
        ...prev.selectedForm,
        template: modifiedTemplate,
      },
    }));

    setEachAnswerToSave({
      tableSectionId: section._id,
      tableSectionDataSource: [...dataSource],
    });
  };

  function handleAddUserClick({ preSelectedUsers }: { preSelectedUsers: any }) {
    const selectedUsers = [...preSelectedUsers];
    const sectionIndex = showAddUsersModal.sectionIndex;
    const fieldIndex = showAddUsersModal.fieldIndex;
    if (showAddUsersModal.source == formSectionType.FORM) {
      const modifiedTemplate = _.cloneDeep(inspectionData.selectedForm.template);
      if (modifiedTemplate[sectionIndex].questionFields[fieldIndex].answer) {
        modifiedTemplate[sectionIndex].questionFields[fieldIndex].answer = {
          ...modifiedTemplate[sectionIndex].questionFields[fieldIndex].answer,
          value: selectedUsers,
        };
      } else {
        modifiedTemplate[sectionIndex].questionFields[fieldIndex].answer = {
          value: selectedUsers,
        };
      }

      setInspectionData((prev: any) => ({
        ...prev,
        selectedForm: {
          ...prev.selectedForm,
          template: modifiedTemplate,
        },
      }));

      setEachAnswerToSave({
        sectionId: modifiedTemplate[sectionIndex]._id,
        questionId: modifiedTemplate[sectionIndex].questionFields[fieldIndex]._id,
        answer: { value: selectedUsers },
      });
    } else {
      const modifiedTemplate = _.cloneDeep(inspectionData.selectedForm.template);

      const modifiedTableDataSource = modifiedTemplate[sectionIndex].tableDataSource.map((row: any, index: any) => {
        if (index == showAddUsersModal.tableRowIndex) {
          row[showAddUsersModal.fieldData._id] = {
            createdDate: Date.now(),
            createdBy: userDetails._id,
            value: selectedUsers,
          };
        }
        return row;
      });

      modifiedTemplate[sectionIndex].tableDataSource = modifiedTableDataSource;

      setInspectionData((prev: any) => ({
        ...prev,
        selectedForm: {
          ...prev.selectedForm,
          template: modifiedTemplate,
        },
      }));

      setEachAnswerToSave({
        tableSectionId: modifiedTemplate[sectionIndex]._id,
        tableSectionDataSource: modifiedTableDataSource,
      });
    }
  }
  const handleURLModalState = ({
    state,
    sectionIndex = 0,
    eachField = 0,
    tableRowIndex = 0,
    answer = {},
    fieldIndex = 0,
    sectionId,
    source,
    tableRowId,
  }: {
    state: any;
    sectionIndex?: any;
    eachField?: any;
    tableRowIndex?: any;
    answer?: any;
    fieldIndex?: any;
    sectionId?: any;
    source?: any;
    tableRowId?: any;
  }) => {
    setShowUrlModal((prev: any) => ({
      ...prev,
      state,
      sectionIndex,
      eachField,
      tableRowIndex,
      answerValue: answer.value,
      fieldIndex,
      sectionId,
      source,
      uniqueId: tableRowId ? `${tableRowId}${eachField._id}` : eachField._id,
    }));
    if (state) {
      setURLData({
        URL: _.get(answer, "value.URL", ""),
        displayText: _.get(answer, "value.displayText", ""),
      });
    } else {
      setURLData({});
    }
  };

  const handleGeoLocationModalState = ({
    sectionIndex,
    eachField,
    tableRowIndex,
    answer,
    fieldIndex,
    sectionId,
    source,
    tableRowId,
    state,
  }: {
    sectionIndex: any;
    eachField: any;
    tableRowIndex: any;
    answer: any;
    fieldIndex: any;
    sectionId: any;
    source: any;
    tableRowId: any;
    state: any;
  }) => {
    setShowGeoLocationModal({
      sectionIndex,
      eachField,
      tableRowIndex,
      answer,
      fieldIndex,
      sectionId,
      source,
      tableRowId,
      state,
      uniqueId: tableRowId ? `${tableRowId}${eachField._id}` : eachField._id,
    });
  };

  const handleSaveUrlData = (handleCustomFieldData: any) => {
    if (!URLData.displayText || !URLData.URL) {
      dispatch(
        showToastNotification({
          content: `${!URLData.displayText ? "Display Text" : "URL"} is Missing`,
          type: TOAST_TYPE_ERROR,
        }),
      );
      return;
    }
    handleURLModalState({ state: false });
    const answerValue = {
      ...URLData,
    };
    const { eachField, sectionIndex, tableRowIndex, fieldIndex, sectionId, source } = showUrlModal;
    const { _id } = eachField;

    if (handleCustomFieldData) {
      handleCustomFieldData({
        eachField: showUrlModal.eachField,
        answerValue,
        fieldIndex: showUrlModal.fieldIndex,
        sectionIndex: showUrlModal.sectionIndex,
        tableRowIndex: showUrlModal.tableRowIndex,
        source: showUrlModal.source,
      });
    } else if (inspectionData._id) {
      if (source == formSectionType.TABLE_SECTION) {
        setInspectionData((prev: any) => {
          const modifiedTemplate = _.cloneDeep(prev.selectedForm.template);
          const modifiedTableDataSource = modifiedTemplate[sectionIndex].tableDataSource.map((row: any, index: any) => {
            if (index == tableRowIndex) {
              row[_id] = {
                createdDate: Date.now(),
                createdBy: userDetails._id,
                value: answerValue,
              };
            }
            return row;
          });
          modifiedTemplate[sectionIndex].tableDataSource = modifiedTableDataSource;

          setEachAnswerToSave({
            tableSectionId: sectionId,
            tableSectionDataSource: modifiedTableDataSource,
          });

          return {
            ...prev,
            selectedForm: {
              ...prev.selectedForm,
              template: modifiedTemplate,
            },
          };
        });
      } else {
        setInspectionData((prev: any) => {
          const modifiedTemplate = _.cloneDeep(prev.selectedForm.template);
          modifiedTemplate[sectionIndex].questionFields[fieldIndex].answer = {
            value: answerValue,
          };
          return {
            ...prev,
            selectedForm: {
              ...prev.selectedForm,
              template: modifiedTemplate,
            },
          };
        });

        setEachAnswerToSave({
          sectionId,
          questionId: _id,
          answer: { value: answerValue },
        });
      }
    }
  };

  const handleChangeUrl = ({ name, value }: { name: any; value: any }) => {
    setURLData((prev: any) => ({ ...prev, [name]: value }));
  };

  function checkWhichSectionsExist({
    section,
    sectionIndex,
    contractDetails,
  }: {
    section: any;
    sectionIndex: any;
    contractDetails: any;
  }) {
    const permissionConstants: any = getPermissionConstants();
    const permission: any = getUserPermissionForForm(inspectionData, userDetails.id, sectionIndex);

    let isCurrentUserAllowed = permission;
    const customModuleSectionHeadings = customModules.map((module: any) => module.name) || [];
    const customModuleSectionCode = customModules.map((module: any) => module.resourceType) || [];
    if (inspectionData.contractId) {
      isCurrentUserAllowed =
        permission &&
        [permissionConstants.CAN_EDIT, permissionConstants.FULL_ACCESS].includes(contractDetails.userRole);
    }

    return {
      isCurrentUserAllowed,
      doesQuantityExist:
        section.sectionHeading == presetSectionsObject.SECTION_TYPE_QUANTITY &&
        section.sectionCode == presetSectionsCodeObject.SECTION_TYPE_QUANTITY,
      doesTaskExist:
        section.sectionHeading == presetSectionsObject.SECTION_TYPE_TASK &&
        section.sectionCode == presetSectionsCodeObject.SECTION_TYPE_TASK,
      doesReferenceExist:
        section.sectionHeading == presetSectionsObject.SECTION_TYPE_REFERENCE &&
        section.sectionCode == presetSectionsCodeObject.SECTION_TYPE_REFERENCE,
      doesLinkedFormExist:
        [
          ...customModuleSectionHeadings,
          presetSectionsObject.SECTION_TYPE_INSPECTION,
          presetSectionsObject.SECTION_TYPE_BILLS,
          presetSectionsObject.SECTION_TYPE_CHANGE_ORDERS,
          presetSectionsObject.SECTION_TYPE_GENERAL_FORMS,
          presetSectionsObject.SECTION_TYPE_PERMIT_TO_WORK,
          presetSectionsObject.SECTION_TYPE_PROGRESS_UPDATES,
        ].includes(section.sectionHeading) &&
        [
          ...customModuleSectionCode,
          presetSectionsCodeObject.SECTION_TYPE_BILLS,
          presetSectionsCodeObject.SECTION_TYPE_CHANGE_ORDERS,
          presetSectionsCodeObject.SECTION_TYPE_GENERAL_FORMS,
          presetSectionsCodeObject.SECTION_TYPE_INSPECTION,
          presetSectionsCodeObject.SECTION_TYPE_PERMIT_TO_WORK,
          presetSectionsCodeObject.SECTION_TYPE_FORM,
          presetSectionsCodeObject.SECTION_TYPE_PROGRESS_UPDATES,
        ].includes(section.sectionCode),
      doesSectionTypeFormsExist:
        section.sectionHeading === presetSectionsObject.SECTION_TYPE_FORM &&
        section.sectionCode == presetSectionsCodeObject.SECTION_TYPE_FORM,
      doesMilestoneExist:
        section.sectionHeading === presetSectionsObject.SECTION_TYPE_MILESTONE &&
        section.sectionCode == presetSectionsCodeObject.SECTION_TYPE_MILESTONE,
      doesWbsItemsExist:
        section.sectionHeading === presetSectionsObject.SECTION_TYPE_WBS_ITEMS &&
        section.sectionCode == presetSectionsCodeObject.SECTION_TYPE_WBS_ITEMS,
      doesSummaryOfChangesExist:
        section.sectionHeading === presetSectionsObject.SECTION_TYPE_SUMMARY_OF_CHANGES &&
        section.sectionCode == presetSectionsCodeObject.SECTION_TYPE_SUMMARY_OF_CHANGES,
      doesReviewsExist:
        section.sectionHeading == presetSectionsObject.SECTION_TYPE_REVIEWS &&
        section.sectionCode == presetSectionsCodeObject.SECTION_TYPE_REVIEWS,
      doesTableSectionExist:
        section.sectionCode && section.sectionCode === presetSectionsCodeObject.SECTION_TYPE_TABLE_SECTION,
    };
  }

  const getTableSectionShowAnsLogic = (section: any, field: any) => {
    return (
      inspectionData.isApproved ||
      inspectionData.isRejected ||
      inspectionData.isArchived?.status ||
      !(
        !(
          getSectionPermission({
            section,
            inspectionData,
            userId: userDetails.id,
            type: "Modify",
          }) && !modifySection.includes(section._id)
        ) &&
        (!section.allowPreDefineRowValues ||
          (section.allowPreDefineRowValues &&
            (!field.allowPreDefinedColValues ||
              (field.allowPreDefinedColValues && section.allowEditPreDefineRowInForm))))
      )
    );
  };

  const getNormalSectionShowAnsLogic = (section: any) => {
    return (
      inspectionData.isApproved ||
      inspectionData.isRejected ||
      inspectionData.isArchived?.status ||
      (getSectionPermission({
        section,
        inspectionData,
        userId: userDetails.id,
        type: "Modify",
      }) &&
        !modifySection.includes(section._id))
    );
  };

  return {
    inspectionData,
    isFileUploading,
    setInspectionData,
    showAttachmentModal,
    setShowAttachmentModal,
    attachmentModalOpenedFor,
    setAttachmentModalOpenedFor,
    sideBarTaskDetails,
    setSideBarTaskDetails,
    eachAnswerToSave,
    setEachAnswerToSave,
    answerSaved,
    setAnswerSaved,
    openCommentDialog,
    setOpenCommentDialog,
    formActionDetails,
    setFormActionDetails,
    accordionExpandedState,
    setAccordionExpandedState,
    showSideBar,
    setShowSideBar,
    showAddUsersModal,
    setShowAddUsersModal,
    showWarningModal,
    setShowWarningModal,
    modifySection,
    setModifySection,
    sideBarScheduleDetails,
    sideBarAccordions,
    setInitialData,
    handleInputChange,
    setEachAnswer,
    // dateFieldFocused,
    openAddUserModal,
    closeUsersModal,
    saveInspectionData,
    removeUserFromList,
    verifySection,
    handleAttachmentClick,
    closeAttachmentModal,
    handleModifyCancel,
    verifyToggleStatus,
    handleFormActionClick,
    beforeOpenActionDropdown,
    handleFormStateChange,
    handleCollapseAll,
    handleExpandAll,
    handleAccStateChange,
    showToastAndRedirect,
    handleSubmitClick,
    closeCommentDialog,
    handleShowWarningModal,
    hideWarningModal,
    GanttDetails,
    userDetails,
    projectData,
    handleSaveCmntClick,
    teamData,
    setTeamData,
    loactionData,
    setLoactionData,
    nameOfTeamLocationRespectToId,
    setNameOfTeamLocationRespectToId,
    setIsDataFetched,
    isDataFetched,
    openAddedUserModalInMobile,
    onClickWarningModalConfirm,
    handleFileUploadChange,
    handleRemoveUploadedFile,
    setTableSectionConfig,
    tableSectionConfig,
    handleExportPdf,
    actionBtnDisabled,
    formObject,
    // addValidationToInputFields,
    handleDeleteTableRow,
    handleAddTableRowClick,
    handleAddUserClick,
    getTeamDataForMobile,
    getLocationForMobile,
    showWaitSpinner,
    selectSignType,
    saveEditedImage,
    verifyAllState,
    imageFieldSelectedIndex,
    setImageFieldSelectedIndex,
    customModules,
    formValidator,
    setOpenExportModal,
    openExportModal,
    handleURLModalState,
    showUrlModal,
    handleSaveUrlData,
    setURLData,
    handleChangeUrl,
    handleChangeAnswer,
    ActionItems,
    showGeoLocationModal,
    setShowGeoLocationModal,
    handleGeoLocationModalState,
    checkWhichSectionsExist,
    getTableSectionShowAnsLogic,
    getNormalSectionShowAnsLogic,
  };
};
export default useForms;
